import * as React from 'react'

const SvgFlashIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.256 18.7a.625.625 0 01-.375-.669l1.138-7.406H5a.625.625 0 01-.625-.769L6.25 1.731a.625.625 0 01.625-.481h6.25a.625.625 0 01.613.762l-1.082 4.863h2.969c.239 0 .457.135.563.35a.625.625 0 01-.07.625L7.995 18.475a.625.625 0 01-.494.275.682.682 0 01-.244-.05zm3.838-10.575l1.25-5.625H7.375L5.787 9.375h3.694L8.488 15.8l5.887-7.675h-3.281z"
      fill="#163250"
    />
  </svg>
)

export default SvgFlashIcon
